module.exports = __webpack_public_path__ + "img/home-cover.abfbf4e9.jpg";